<template>
  <div
    class="cursor"
    v-if="!hidden"
    :class="[getCursor, rotateCursor && !loadingCursor ? 'rotate' : '', loadingCursor ? 'loading' : '', negativeCursor && !loadingCursor ? 'negative' : '']"
    :style="{'top' : top, 'left' : left}"
    ref="cursor"
  >
    <div class="inner" :data-loading="loadingState"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    isIntro: {
      default: false
    }
  },
  data() {
    return {
      activeHover: "",
      hidden: true,
      top: 0,
      left: 0
    };
  },
  mounted() {
    let cursor = this.$refs.cursor;
    this.hidden = false;

    document.addEventListener("mousemove", e => {
      this.top = e.clientY + "px";
      this.left = e.clientX + "px";
    });

    document.addEventListener("mouseover", e => {
      if (
        !e.target.dataset["hover"] &&
        !e.target.localName === "a" &&
        !this.isIntro
      ) {
        this.setCursor(e, "none");
        return;
      }
      if (e.target.dataset["hover"]) {
        this.setCursor(e, e.target.dataset["hover"]);
      } else if (e.target.localName === "a") {
        this.setCursor(e);
      } else if (e.target.classList.contains('iubenda-cs-close-btn')) {
        this.setCursor(e, 'link');
      } else {
        if (this.isIntro) {
          this.setCursor(e, "scroll");
        } else {
          this.setCursor(e, "none");
        }
      }
      this.setNegative(e);
    });
  },
  computed: {
    ...mapGetters([
      "getCursor",
      "rotateCursor",
      "loadingCursor",
      "loadingState",
      "negativeCursor"
    ])
  },
  methods: {
    setCursor(e, type) {
      if (this.getCursor === type) {
        return;
      }
      this.$store.commit("changeCursor", type || "link");
    },
    setNegative(e) {
      if ( e.target.dataset["negative"] ) {
        this.$store.commit("negativeCursor", true);
      } else {
        this.$store.commit("negativeCursor", false);
      }
    }
  }
};
</script>

<style lang="scss">
@import "@assets/scss/_importer.scss";
@include breakpoint(large up) {
  * {
    cursor: none !important;
  }

  *[data-hover] {
    & * {
      pointer-events: none;
    }
    & *[data-hover] {
      pointer-events: all;
    }
  }
}
</style>


<style lang="scss" scoped>
@import "@assets/scss/_importer.scss";

@keyframes size-anim {
  0%,
  100% {
    @include transform(scale(1));
  }
  50% {
    @include transform(scale(0.9));
  }
}

@-moz-keyframes size-anim {
  0%,
  100% {
    @include transform(scale(1));
  }
  50% {
    @include transform(scale(0.9));
  }
}

@-webkit-keyframes size-anim {
  0%,
  100% {
    @include transform(scale(1));
  }
  50% {
    @include transform(scale(0.9));
  }
}

@keyframes size-anim-text {
  0%,
  100% {
    @include transform(scale(1));
  }
  50% {
    @include transform(scale(1.1));
  }
}

@-moz-keyframes size-anim-text {
  0%,
  100% {
    @include transform(scale(1));
  }
  50% {
    @include transform(scale(1.1));
  }
}

@-webkit-keyframes size-anim-text {
  0%,
  100% {
    @include transform(scale(1));
  }
  50% {
    @include transform(scale(1.1));
  }
}

@keyframes rotate {
  from {
    @include transform(rotate(0deg));
  }
  to {
    @include transform(rotate(360deg));
  }
}

@-moz-keyframes rotate {
  from {
    @include transform(rotate(0deg));
  }
  to {
    @include transform(rotate(360deg));
  }
}

@-webkit-keyframes rotate {
  from {
    @include transform(rotate(0deg));
  }
  to {
    @include transform(rotate(360deg));
  }
}

.cursor {
  @include transform(translateX(-50%) translateY(-50%));
  pointer-events: none;
  z-index: 10000;
  position: fixed;
  height: 8px;
  width: 8px;
  transition: width 0.4s, height 0.4s, filter 0.4s;
  @include breakpoint(medium down) {
    display: none;
  }
  &.negative:not(.loading) {
    filter: invert(1);
  }
  .inner {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: $secondary-color;
    transition: background 0.4s, transform 0.8s;
    border-radius: 50%;
    overflow: hidden;
  }
  &.rotate:not(.loading) {
    .inner {
        &::before{
          background-position: 100% 0 !important;
          transition: background-position .4s;
        }
    }
  }
  &.scroll:not(.loading) {
    height: 64px;
    width: 64px;
    .inner {
      background: rgba($secondary-color, 0.5);
      animation: size-anim 2s ease-in-out infinite;
      &::before {
        content: "SCROLL";
        text-align: center;
        color: $white;
        line-height: 64px;
        font-weight: $global-weight-bold;
        font-size: 12px;
        letter-spacing: 1px;
        display: block;
        width: 100%;
        animation: size-anim-text 2s ease-in-out infinite;
      }
    }
  }
  &.slider:not(.loading) {
    height: 64px;
    width: 64px;
    .inner {
      background: rgba($secondary-color, 0.5);
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -100%;
        height: 100%;
        width: 200%;
        background-size: cover;
        background-position: center;
        -webkit-background-size: cover;
        background-image: url(../../assets/img/cursor/slider.svg);
        background-size: 50% 100%;
        background-position: 0 0;
      }
    }
  }
  &.link:not(.loading) {
    height: 32px;
    width: 32px;
    .inner {
      background: rgba($secondary-color, 0.5);
    }
  }
  &.loading {
    height: 64px;
    width: 64px;
    .inner {
      background: rgba($secondary-color, 0.5);
      animation: size-anim 2s ease-in-out infinite;
      &::before {
        content: attr(data-loading);
        text-align: center;
        color: $white;
        line-height: 64px;
        font-weight: $global-weight-bold;
        font-size: 12px;
        letter-spacing: 1px;
        display: block;
        width: 100%;
        animation: size-anim-text 2s ease-in-out infinite;
      }
    }
  }
}
</style>
